import Icon, { IconNames } from 'components/Icon';
import { ENV_CONFIG } from 'config/environment';
import { getPageImageUrl } from 'helpers/imageUrls';
import { getPathWithRef } from 'helpers/utils';
import theme from 'config/theme';
import { FC, useState } from 'react';
import { IPageBase } from 'store/pages/types';

interface Props {
  className: string;
  isComplete: boolean;
  page: IPageBase;
  amount: number;
  refCode: string;
}

export const Issue: FC<Props> = ({ className, isComplete, page, amount, refCode }) => {
  const [bannerState, setBannerState] = useState<'loading' | 'loaded' | 'failed'>('loading');

  return (
    <div className={`cycle-issue ${className}`}>
      {/* sr-only rather than unmounted: the banner is alt="", so this div is the
          tile's accessible name. Hidden once the banner loads because artwork with
          transparent space would otherwise let it show through. */}
      <div className={bannerState === 'loaded' ? 'sr-only' : 'issue-name'}>{page.value}</div>
      {bannerState !== 'failed' && (
        <img
          className="issue-banner"
          src={getPageImageUrl(page)}
          alt=""
          onLoad={() => setBannerState('loaded')}
          onError={() => setBannerState('failed')}
        />
      )}
      {isComplete ? (
        <div className="issue-checkmark" aria-label="Complete">
          <Icon name={IconNames.Checkmark} color={theme.colors.white} size={18} />
        </div>
      ) : (
        <a
          className="button-brand issue-give"
          href={getPathWithRef(
            `${ENV_CONFIG().SITE_URL}/donate?p=${page.query_str}&amount=${amount}${refCode}`
          )}
          target="_blank"
          rel="noreferrer"
        >
          Give
        </a>
      )}
    </div>
  );
};
